import React, { FC, useCallback, useEffect } from "react"
import { useDispatch } from "react-redux"
import { changeInputValue } from "../../../Actions/Client/InputRender/InputRenderActions"
import type { AjvError } from "@rjsf/core"
import { MainThunkDispatch } from "../../../Reducers"
import {
    InputFormRender,
    InputFormRenderProps
} from "../InputFormRender/InputFormRender"

interface InputFormRenderContainerProps
    extends Omit<
        InputFormRenderProps,
        "onChange" | "onError" | "onSubmit" | "liveValidate"
    > {
    id: string
    defaultData: unknown
}

export const InputFormRenderContainer: FC<InputFormRenderContainerProps> = ({
    id,
    formData,
    defaultData,
    ...restProps
}) => {
    const dispatch = useDispatch<MainThunkDispatch>()

    const handleChange = useCallback(
        (formData: unknown, errors: AjvError[]) => {
            dispatch(
                changeInputValue(id, {
                    values: formData,
                    surviveReroute: true,
                    errors: [],
                    formErrors: errors
                })
            )
        },
        [id, dispatch]
    )

    useEffect(() => {
        dispatch(
            changeInputValue(id, {
                values: defaultData,
                surviveReroute: true,
                errors: [],
                formErrors: []
            })
        )
    }, [id, defaultData, dispatch])

    return (
        <InputFormRender
            id={id}
            formData={formData ?? defaultData}
            onChange={handleChange}
            liveValidate={true}
            {...restProps}
        />
    )
}
